import { useMedia } from './useMedia.mjs';

function useScreenSize(size) {
  return useMedia(`(min-width: ${size}px)`);
}

export { useScreenSize };
//# sourceMappingURL=useScreenSize.mjs.map
